import { render, staticRenderFns } from "./userAvatar.vue?vue&type=template&id=c941cc72&scoped=true"
import script from "./userAvatar.vue?vue&type=script&lang=js"
export * from "./userAvatar.vue?vue&type=script&lang=js"
import style0 from "./userAvatar.vue?vue&type=style&index=0&id=c941cc72&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c941cc72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\0.资料\\项目\\girdear_mall_center_web\\node_modules\\.store\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c941cc72')) {
      api.createRecord('c941cc72', component.options)
    } else {
      api.reload('c941cc72', component.options)
    }
    module.hot.accept("./userAvatar.vue?vue&type=template&id=c941cc72&scoped=true", function () {
      api.rerender('c941cc72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/system/user/profile/userAvatar.vue"
export default component.exports